import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import selectionLayers from '../fixtures/selectionLayers';
import ValueSquare from './valueSquare';
import style from './oldLayerBlock.css';

class OldLayerBlock extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        className={(() => {
          const w = this.props.screenWidth;
          const maxColumns = selectionLayers[this.props.displayLayer].maxColumns;
          // const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

          if (w > 700 && maxColumns > 5) {
            return style.centeredDynamicBlock;
          } else if (w > 600 && maxColumns > 4) {
            return style.centeredFiveBlock;
          } else if (w > 520 && maxColumns > 3) {
            return style.centeredFourBlock;
          } else if (w > 400 && maxColumns > 2) {
            return style.centeredThreeBlock;
          } else if (w > 280 && maxColumns > 1) {
            return style.centeredTwoBlock;
          }
          return style.centeredOneBlock;
        })()}
      >
        <div className={style.wordColumnBlock}>
          { (() => _.map(
              this.props.randomIdList,
              randId =>
                (this.props.valuesObject[randId].layer === this.props.displayLayer ?
                    (<ValueSquare
                      overrideStyle={selectionLayers[this.props.displayLayer].layerStyle}
                      key={this.props.valuesObject[randId].id}
                      valueId={this.props.valuesObject[randId].id}
                      canSelect={false}
                      isSelected={false}
                      displayTitle={this.props.valuesObject[randId].word}
                    />)
                  :
                    ''
                  )))()
          }
        </div>
      </div>
    );
  }
}

// This is totally optional, but forces react to check the prop types
// when running in debug
OldLayerBlock.propTypes = {
  screenWidth: PropTypes.number.isRequired,
  displayLayer: PropTypes.number.isRequired,
  valuesObject: PropTypes.object.isRequired,
  randomIdList: PropTypes.array.isRequired,
};


function mapStateToProps(state, props) {
  // console.log(state.valueSet);
  return {
    valuesObject: state.valueSet.values,
    randomIdList: state.valueSet.randomizedIds,
  };
}
function mapDispatchToProps(dispatch) {
  return {

  };
}
export default connect(mapStateToProps, mapDispatchToProps)(OldLayerBlock);



// WEBPACK FOOTER //
// ./src/components/oldLayerBlock.js